// extracted by extract-css-chunks-webpack-plugin
module.exports = {"link":"_3RbG7e","text":"_3AYE5M","arrow":"_2YiSCP","titleLink":"tPIo_0","title":"_2ZY3TT","arrowHolder":"_1Dy_37","status":"_3yBnhV","urgent":"_1U6Kah"};